import { initiateLiveChat, makeTrackLiveChat } from '../../../helpers/general-helper/general-helper';
import { useTrackEvent } from '../analytics.hooks';

export const useLiveChat = () => {
	const trackEvent = useTrackEvent();
	const trackLiveChat = makeTrackLiveChat(trackEvent);

	return () => initiateLiveChat(trackLiveChat);
};
